module.exports = __webpack_public_path__ + "static/media/dumbbellCorrect.70e08bcf.png";